import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { initials } from '../pages/admin/ProfileMenu';
import { ROLES, hasAnyRole, profilePathFor, canUseStaffMode } from '../auth/roles';
import { paths } from '../routes/paths';
import '../styles/accountMenu.css';

// Avatar in the top-right corner of the site header and of every panel. Opens a card with who is signed in, "My profile" and "Log out" (Payment methods is a card inside every profile page, not a menu entry);
// closes on outside click, Escape or after a choice.
export default function AccountMenu({ user, onLogout }) {
  const [open, setOpen] = useState(false);
  // one entry for the admin and for the organiser: each goes to their own panel
  const controlPanel = hasAnyRole(user, [ROLES.ADMIN]) ? paths.admin.root : hasAnyRole(user, [ROLES.ORGANISER_OWNER]) ? paths.organiser.dashboard : null;
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div className="acct" ref={ref}>
      <button type="button" className="acct-avatar" onClick={() => setOpen(!open)} aria-haspopup="menu" aria-expanded={open} aria-label="Open account menu">
        {initials(user?.fullName)}
      </button>
      {open && (
        <div className="acct-menu" role="menu">
          <div className="acct-head">
            <span className="acct-avatar" aria-hidden="true">{initials(user?.fullName)}</span>
            <div>
              <b>{user?.fullName}</b>
              <span>{user?.email}</span>
            </div>
          </div>
          {controlPanel && <Link to={controlPanel} role="menuitem" className="acct-item" onClick={() => setOpen(false)}>Control panel</Link>}
          <Link to={profilePathFor(user)} role="menuitem" className="acct-item" onClick={() => setOpen(false)}>My profile</Link>
          {canUseStaffMode(user) && <Link to={paths.staff.root} role="menuitem" className="acct-item" onClick={() => setOpen(false)}>Staff mode</Link>}
          <button type="button" role="menuitem" className="acct-item" onClick={() => { setOpen(false); onLogout(); }}>Log out</button>
        </div>
      )}
    </div>
  );
}
